import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { fetchUnreadCount } from '@/backend/messageServiceApi'
import { MESSAGES_UNREAD_QUERY_KEY } from '@/queryClient'
import { formatUnreadBadge } from '@/components/notifications/notificationLogic.mjs'
import { useNotificationUser } from '@/composables/useNotificationUser'

export function useUnreadNotifications() {
  const { isAuthenticated } = useNotificationUser()
  const unreadQuery = useQuery({
    queryKey: [MESSAGES_UNREAD_QUERY_KEY],
    queryFn: ({ signal }) => fetchUnreadCount({ signal }),
    enabled: computed(() => isAuthenticated.value),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  })
  const unreadCount = computed(() => Number(unreadQuery.data.value) || 0)
  const badgeText = computed(() => formatUnreadBadge(unreadCount.value))

  return { unreadQuery, unreadCount, badgeText }
}
